// size chart
let region;
const dropdown_toggle = document.querySelector(".js-selector-button");
const country_dropdown = document.querySelector(".js-country-dropdown");

async function getCurrentCountry() {
  const url = `${window.Shopify.routes.root}browsing_context_suggestions.json`;
  const response = await fetch(url);

  if (response.status !== 200) return;
  const data = await response.json();
  const country = data.detected_values.country_name;

  if (country === "United States" || country === "Canada") {
    region = "US";
    sessionStorage.setItem("Region", region);
  } else if (country === "France") {
    region = "France";
    sessionStorage.setItem("Region", region);
  } else if (country === "Australia" || country === "New Zealand") {
    region = "Australia_and_New_Zealand";
    sessionStorage.setItem("Region", region);
  } else if (
    country === "China" ||
    country === "China (PRC)" ||
    country === "Hong Kong"
  ) {
    region = "Asia";
    sessionStorage.setItem("Region", region);
  } else if (country === "Russia") {
    region = "Russia";
    sessionStorage.setItem("Region", region);
  } else {
    region = "Default";
    sessionStorage.setItem("Region", region);
  }
  setRegions(region);
  setTables(region);
  toggleDropDown();
}

function setRegions(region) {
  let label = "";
  switch (region) {
    case "Default":
      label = "UK and Europe";
      break;
    case "US":
      label = "US & Canada";
      break;
    case "France":
      label = "France";
      break;
    case "Australia_and_New_Zealand":
      label = "Australia and New-Zealand";
      break;
    case "Asia":
      label = "China";
      break;
    case "Russia":
      label = "Russia";
      break;
    default:
      console.log("Default");
      break;
  }
  const currentCountryElement = document.getElementById("jsCurrent_country");
  if (currentCountryElement) {
    currentCountryElement.innerText = label;
  }
  setCountry(currentCountryElement);
}

function setTables(region) {
  const allTables = document.querySelectorAll(".content-size-table");
  const countryTableDefault = document.querySelectorAll(
    ".js-size-chart_default",
  );
  const countryTableUS = document.querySelectorAll(".js-size-chart_us");
  const countryTableFrance = document.querySelectorAll(".js-size-chart_fr");
  const countryTableAustraliaAndNewZealand = document.querySelectorAll(
    ".js-size-chart_au_and_nz",
  );
  const countryTableAsia = document.querySelectorAll(".js-size-chart_asia");
  const countryTableRussia = document.querySelectorAll(".js-size-chart_ru");

  switch (region) {
    case "Default":
      allTables.forEach((table) => {
        table.style.display = "none";
      });
      countryTableDefault.forEach((table) => {
        table.style.display = "table";
      });
      break;
    case "US":
      allTables.forEach((table) => {
        table.style.display = "none";
      });
      countryTableUS.forEach((table) => {
        table.style.display = "table";
      });
      break;
    case "France":
      allTables.forEach((table) => {
        table.style.display = "none";
      });
      countryTableFrance.forEach((table) => {
        table.style.display = "table";
      });
      break;
    case "Australia_and_New_Zealand":
      allTables.forEach((table) => {
        table.style.display = "none";
      });
      countryTableAustraliaAndNewZealand.forEach((table) => {
        table.style.display = "table";
      });
      break;
    case "Asia":
      allTables.forEach((table) => {
        table.style.display = "none";
      });
      countryTableAsia.forEach((table) => {
        table.style.display = "table";
      });
      break;
    case "Russia":
      allTables.forEach((table) => {
        table.style.display = "none";
      });
      countryTableRussia.forEach((table) => {
        table.style.display = "table";
      });
      break;
    default:
      console.log("Default");
      break;
  }
}

function setCountry(currentRegionSelector) {
  const country_dropdown = document.querySelector(".js-country-dropdown");
  const country_buttons = document.querySelectorAll(".js-country");
  country_buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const current_region = btn.dataset.value;
      sessionStorage.setItem("Region", current_region);
      currentRegionSelector.innerText = btn.innerText;
      setTables(current_region);
      dropdown_toggle.classList.remove("active");
      country_dropdown.classList.remove("active");
    });
  });
}

function toggleDropDown() {
  if (dropdown_toggle) {
    dropdown_toggle.addEventListener("click", () => {
      dropdown_toggle.classList.toggle("active");
      country_dropdown.classList.toggle("active");
    });
  }

  document.addEventListener("click", (event) => {
    if (!dropdown_toggle.contains(event.target)) {
      dropdown_toggle.classList.remove("active");
      country_dropdown.classList.remove("active");
    }
  });
}

function initSizeChart() {
  console.log("init size chart");
  const savedRegion = sessionStorage.getItem("Region");
  if (!savedRegion) {
    getCurrentCountry();
  } else {
    region = savedRegion;
    setRegions(region);
    setTables(region);
    toggleDropDown();
  }
}
const sizeChart = document.querySelector(".size-chart-modal");
const contentSections = document.querySelectorAll(
  ".js-size-chart-content > div",
);
const defaultButton = document.querySelector(
  ".js-size-chart-nav button.active",
);
if (defaultButton) {
  const dataShowContentValue = defaultButton.getAttribute("data-show-content");
  document.querySelector(".js-content-" + dataShowContentValue).style.display =
    "flex";
}

function hideAllContent() {
  contentSections.forEach((section) => {
    section.style.display = "none";
  });
}

function deactivateAllButtons() {
  navButtons.forEach((button) => {
    button.classList.remove("active");
  });
}

function handleButtonClick(event) {
  deactivateAllButtons();
  hideAllContent();

  event.target.classList.add("active");

  const selected = event.target.dataset.showContent;

  const content = document.querySelector(`.js-content-${selected}`);
  if (content) {
    content.style.display = "flex";
  }
}

const navButtons = document.querySelectorAll(".js-size-chart-nav button");
if (navButtons) {
  navButtons.forEach((button) => {
    button.addEventListener("click", handleButtonClick);
  });
}

function toggleSlideOut(sizeChartOverlay) {
  sizeChart.classList.toggle("show");
  sizeChartOverlay.classList.toggle("active");
  document.getElementsByTagName("html")[0].classList.toggle("no_scroll");
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("LOADED");
  const openModal = document.querySelector(".js-open-modal_size-chart");
  const productForm = document.querySelector(".section-main-product");
  const closeModal = document.querySelector(".js-close-size-chart-modal");
  const sizeChartOverlay = document.querySelector(".size-chart-modal__overlay");
  initSizeChart();

  if (openModal && productForm) {
    const toggle = (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleSlideOut(sizeChartOverlay);
    };

    // initSizeChart();
    if (closeModal && sizeChartOverlay) {
      closeModal.addEventListener("click", (e) => toggle(e));
      sizeChartOverlay.addEventListener("click", (e) => toggle(e));
    }

    productForm.addEventListener("click", (e) => {
      if (e.target.classList.contains("js-open-modal_size-chart")) {
        toggle(e);
      }
    });
  }
});
